import { ISystemRequirementTypeProps } from "./ISystemRequirementTypeProps";
import styles from "./SystemRequirementType.module.scss";
import React from "react";
import { SingleSelectionDropDown } from "../../../components/selection/singleSelectionDropDown/SingleSelectionDropDown";
import { ISystemRequirement } from "../../../shared/model/ISystemRequirement";

export const SystemRequirementType: React.FC<ISystemRequirementTypeProps> = (
  props
) => {

  const onSystemRequirementChanged = (systemRequirement: ISystemRequirement | undefined, previousRequirement: ISystemRequirement | undefined) => {
    if(systemRequirement && !previousRequirement){
      props.onSystemRequirementChanged([
        ...props.activeRequirements,
        systemRequirement.SYSTEM_REQUIREMENT_ID,
      ]);
    }
    if(systemRequirement && previousRequirement &&
       systemRequirement.SYSTEM_REQUIREMENT_ID !== previousRequirement.SYSTEM_REQUIREMENT_ID){
      const updatedCheckedRequirements = props.activeRequirements.map(id =>
        id === previousRequirement.SYSTEM_REQUIREMENT_ID ? systemRequirement.SYSTEM_REQUIREMENT_ID : id
      );
      props.onSystemRequirementChanged(updatedCheckedRequirements);
    }
  }

  const isRequired =
    props.systemRequirementType.SYSTEM_REQUIREMENTS.length > 0;
  const hasError =
    props.highlightMissingSelection === true &&
    isRequired &&
    !props.hasSelectedSystemRequirement(props.systemRequirementType);

  return (
    <div>
      <h4 className={styles.headline}>
        {props.systemRequirementType.DESCRIPTION}
      </h4>
      <div className={styles.selection}>
        <SingleSelectionDropDown
          editMode={props.editMode}
          objects={props.systemRequirementType.SYSTEM_REQUIREMENTS}
          isSelected={props.isSystemRequirementSelected}
          getName={(systemRequirement) => systemRequirement.DESCRIPTION}
          getInternalId={(systemRequirement) => systemRequirement.SYSTEM_REQUIREMENT_ID}
          getObjectId={(systemRequirement) => systemRequirement.OBJECT_ID}
          onSelectionChanged={onSystemRequirementChanged}
          hasError={hasError}
        />
      </div>
    </div>
  );
};
